<div class="mat-typography">
  <div class="login-form">
    <div class="title">Teste de time-out</div>
    <form [formGroup]="mainFormGroup">
      <div class="form-div">
        <mat-form-field  class="input-class">
          <mat-label>Time-out em milisegundos</mat-label>
          <input matInput type="text" placeholder="Tempo para o time-out" formControlName="time" />
        </mat-form-field>
      </div>

      <div class="form-div">
        <button type="button" mat-button (click)="timeout()" class="main-button">Iniciar</button>
      </div>
    </form>
  </div>
</div>
